<template>
  <div class="ProductionRecord mainWrap" v-loading.fullscreen.lock="fullscreenLoading">
    <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav msg="/EP001"></leftNav>
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-container>
        <!-- 页面部分 -->
        <el-scrollbar class="machineWrap" style="height:100%;width:100%">
          <el-main>
            <div class="mainWrao">
              <div class="recordTitle">
                <h1>{{$t('leftNav.nav26')}}</h1>
                <div class="machineSeach">
                  <label style="margin-right:10px;font-size:12px;">{{$t('Production.labelTitle')}}</label>
                  <!-- <el-cascader
                    class="idStyle"
                    @change="getShiftTime()"
                    :placeholder="$t('Production.placehoder1')"
                    expand-trigger="hover"
                    :options="options"
                    filterable
                    v-model="machineID">
                  </el-cascader> -->
                  <equipment @change="getchange" class="machinevue" :machine="machineID[1]"></equipment>
                </div>
              </div>
              
              <div class="barWrap">
                <el-tabs type="border-card" class="barTabs" v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane :label="$t('leftNav.nav26')" name="day" class="barTabsDay">
                    <!-- 柱状图1 -->
                    <div class="barChart">
                      <div class="seach">
                        <el-date-picker
                          class="dataWrap"
                          @change="clearDis"
                          v-model="datePicker"
                          :clearable="false"
                          :picker-options="pickerOptions"
                          popper-class="dataDownChoose"
                          type="datetimerange"
                          format="yyyy-MM-dd HH:mm"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          range-separator="—"
                          :start-placeholder="$t('Production.StartTime')"
                          :end-placeholder="$t('Production.EndTime')">
                        </el-date-picker>
                        <!-- <el-button @click="showBtn()" type="primary" icon="el-icon-view">{{$t('Production.showBtn')}}</el-button> -->
                      </div>
                      <!-- 柱状图 -->
                      <!-- <div v-show="noMachine" class="noMachineTitle">{{$t('WorkShopDashBoard.noEquipmentData')}}</div> -->
                      <div id="chartWrap" style="width:100%; margin-bottom:30px;">
                        <div v-if="machineTitle !== ''" class="chartLine">
                          <div class="chartTopTitle">
                            <div v-show="$store.state.lang===0" class="chartTitle">{{'Green Tire Count of ' + machineTitle}}</div>
                            <div v-show="$store.state.lang===1" class="chartTitle">{{machineTitle + ' 的生胎数量'}}</div>
                            <p>{{titleStartTime}} ~ {{titleEndTime}}</p>
                          </div>
                          <div class="chartConfiguration" v-if="!noMachine">
                            <el-button icon="el-icon-s-operation" size="mini" @click="saveLeft()"></el-button>
                          </div>
                        </div>
                        <div v-if="noMachine" class="noMachineTitle">{{$t('WorkShopDashBoard.noEquipmentTableMessage')}}</div>
                        <div id="myDayChart" style="height:700px; margin:0 auto;"></div>
                      </div>
                    </div>
                    <!-- 柱状图2 -->
                    <div class="barChart">
                      <div class="seach" >
                        <el-date-picker
                          class="dataWrap"
                          popper-class="dataDownChoose"
                          @change="clearDis2"
                          v-model="datePicker2"
                          :clearable="false"
                          :picker-options="pickerOptions2"
                          type="datetimerange"
                          format="yyyy-MM-dd HH:mm"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          range-separator="—"
                          :start-placeholder="$t('Production.StartTime')"
                          :end-placeholder="$t('Production.EndTime')">
                        </el-date-picker>
                        <!-- <el-button @click="showBtn2()" type="primary" icon="el-icon-view">{{$t('Production.showBtn')}}</el-button> -->
                      </div>
                      <!-- 柱状图 -->
                      <!-- <div v-show="noMachine" class="noMachineTitle">{{$t('WorkShopDashBoard.noEquipmentData')}}</div> -->
                      <div id="chartWrap" style="width:100%; margin-bottom:30px;" >
                        <div v-if="machineTitle2 !== ''" class="chartLine">
                          <div class="chartTopTitle">
                            <div v-show="$store.state.lang===0" class="chartTitle">{{'Green Tire Count of ' + machineTitle2}}</div>
                            <div v-show="$store.state.lang===1" class="chartTitle">{{machineTitle2 + ' 的生胎数量'}}</div>
                            <p>{{titleStartTime2}} ~ {{titleEndTime2}}</p>
                          </div>
                          <div class="chartConfiguration" v-if="!noMachine2">
                            <el-button icon="el-icon-s-operation" size="mini" @click="saveRight()"></el-button>
                          </div>
                        </div>
                        <div v-if="noMachine2" class="noMachineTitle">{{$t('WorkShopDashBoard.noEquipmentTableMessage')}}</div>
                        <div id="myDayChart2" style="height:700px; margin:0 auto;"></div>
                      </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('leftNav.nav27')" name="week"></el-tab-pane>
                  <el-tab-pane :label="$t('leftNav.nav28')" name="month"></el-tab-pane>
                </el-tabs>

              </div>
            </div>
          </el-main>
        </el-scrollbar>
      </el-container>
    </el-container>
    <el-dialog
      :visible.sync="dialogVisible"
      width="540px"
      center>
      <span slot="title" class="dialog-title">
        <b>{{$t('Production.dialogTitle')}}</b>
      </span>
      <p class="axis">{{$t('Production.dialogTitle2')}}</p>
      <div v-show="showSelect === 'a'">
        <div class="dialogSelect">
          <label>{{$t('Production.dialogLabel1')}}</label>
          <el-select v-model="selectValue1" placeholder="请选择">
            <el-option
              v-for="item in selectoptions1"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled">
            </el-option>
          </el-select>
        </div>
        <div class="dialogSelect">
          <label>{{$t('Production.dialogLabel2')}}</label>
          <el-select v-model="selectValue2" placeholder="请选择">
            <el-option
              v-for="item in selectoptions2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled">
            </el-option>
          </el-select>
        </div>
      </div>
      <div v-show ="showSelect === 'b'">
        <div class="dialogSelect">
          <label>{{$t('Production.dialogLabel1')}}</label>
          <el-select v-model="chart2selectValue1" placeholder="请选择">
            <el-option
              v-for="item in selectoptions1"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled">
            </el-option>
          </el-select>
        </div>
        <div class="dialogSelect">
          <label>{{$t('Production.dialogLabel2')}}</label>
          <el-select v-model="chart2selectValue2" placeholder="请选择">
            <el-option
              v-for="item in selectoptions2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled">
            </el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancle()">{{$t('Production.dialogCancel')}}</el-button>
        <el-button type="primary" @click="handleconfirm()">{{$t('Production.dialogOk')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { formatDate } from '../assets/js/date.js'
import leftNav from "@/components/nav.vue"
import equipment from "@/components/Equipment.vue"
export default {
  name: 'ProductionRecord',
  components: {
    leftNav,
    equipment
  },
  data () {
    return {
      resizeTimer: null,
      resizeTimer2: null,
      barChart: null,
      barChart2: null,
      //  模拟数据
      options: [],
      // 选中的机械id
      machineID: [],
      // 选项
      radio: 1,
      radio2: 1,
      // 选择时间
      datePicker: null,
      datePicker2: null,
      // 显示隐藏echart
      // 禁用日期
      datedis: true,
      datedis2: true,
      machineTitle: '',
      machineTitle2: '',
      titleStartTime: '',
      titleEndTime: '',
      titleStartTime2: '',
      titleEndTime2: '',
      fullscreenLoading: false,
      timeArr: [],
      numArr: [],
      workTimeArr: [],
      chart2_timeArr: [],
      chart2_numArr: [],
      chart2_workTimeArr: [],
      // 散点图数据
      pointPosition:[],
      pointPosition2:[],
      // 显示隐藏弹出框
      dialogVisible: false,
      // 显示那个下拉框
      showSelect: 'a',
      // 选择的间隔时间
      selectValue1: '2',
      chart2selectValue1: '2',
      // X轴坐标
      selectValue2: '2',
      chart2selectValue2: '2',
      selectoptions1: [{
        value: '1',
        label: '1'+ this.$t('Production.hourTitle')
      }, {
        value: '2',
        label: '2'+ this.$t('Production.hoursTitle')
      }, {
        value: '12',
        label: '12'+ this.$t('Production.hoursTitle')
      }, {
        value: '24',
        label: '24'+ this.$t('Production.hoursTitle')
      }, {
        value: '1S',
        label: '1'+ this.$t('Production.shiftTitle')
      }],
      selectoptions2: [{
        value: '1',
        label: 'XX:00'
      }, {
        value: '2',
        label: 'XX:30',
      }],
      // 选择器逻辑
      twoShiftArr: null,
      threeShiftArr: null,
      pickerMinDate: '',
      pickerOptions: {
        onPick: ({minDate}) => {
          this.pickerMinDate = minDate.getTime()
        },
        disabledDate: (time) =>{
          if (this.pickerMinDate !== '') {
            const day30 = 7 * 24 * 3600 * 1000
            let maxTime = this.pickerMinDate + day30
            let minTime = this.pickerMinDate - day30
            return (time.getTime() > maxTime ||
                      time.getTime() < minTime)
          }
        },
        shortcuts: [{
          text: this.$t('Production.radio1'),
          onClick:(picker)=> {
            if (this.twoShiftArr === null) {
              this.$message.error(this.$t('Production.error1'));
            } else {
              picker.$emit('pick', this.twoShiftArr);
            }
          }
        }, {
          text: this.$t('Production.radio2'),
          onClick:(picker)=> {
            if (this.threeShiftArr === null) {
              this.$message.error(this.$t('Production.error1'));
            } else {
              picker.$emit('pick', this.threeShiftArr);
            }
          }
        }]
      },
      pickerMinDate2: '',
      pickerOptions2: {
        onPick: ({minDate}) => {
          this.pickerMinDate2 = minDate.getTime()
        },
        disabledDate: (time) =>{
          if (this.pickerMinDate2 !== '') {
            const day30 = 7 * 24 * 3600 * 1000
            let maxTime = this.pickerMinDate2 + day30
            let minTime = this.pickerMinDate2 - day30
            return (time.getTime() > maxTime ||
                      time.getTime() < minTime)
          }
        },
        shortcuts: [{
          text: this.$t('Production.radio1'),
          onClick:(picker)=> {
            if (this.twoShiftArr === null) {
              this.$message.error(this.$t('Production.error1'));
            } else {
              picker.$emit('pick', this.twoShiftArr);
            }
          }
        }, {
          text: this.$t('Production.radio2'),
          onClick:(picker)=> {
            if (this.threeShiftArr === null) {
              this.$message.error(this.$t('Production.error1'));
            } else {
              picker.$emit('pick', this.threeShiftArr);
            }
          }
        }]
      },
      // 图表1的暂存数据（用于导出）
      chart1Info:{
        time:null,
        machineId:null
      },
      dltime:null,
      dlmachineId:'',
      // 图表2的暂存数据
      chart2Info:{
        time:null,
        machineId:null
      },
      dltime2:null,
      dlmachineId2:'',
      noMachine:false,
      noMachine2:false,
      activeName:'day'
    }
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    }
  },
  watch: {
    islangChange (curval, oldval) {
      if (curval != oldval) {
        this.$parent.reload()
      }
    }
  },
  created(){
    //获取今天时间
    let date = new Date()
    let tYear = date.getFullYear();
    let tMonth = date.getMonth()+1;
    let tDate = date.getDate();
    let startDate1 = new Date(`${tYear}/${tMonth}/${tDate} 00:00:00`)
    let endDate1 = new Date(`${tYear}/${tMonth}/${tDate} 23:59:59`)
    this.datePicker = [formatDate(new Date(startDate1), 'yyyy-MM-dd hh:mm:ss'),formatDate(new Date(endDate1), 'yyyy-MM-dd hh:mm:ss')]
    
    //获取昨天
    let startChuo = startDate1.getTime()-86400000
    let startDate = new Date(startChuo)
    let startYear = startDate.getFullYear();
    let startMonth = startDate.getMonth()+1;
    let startD = startDate.getDate();
    let startDate2 =new Date(`${startYear}/${startMonth}/${startD} 00:00:00`)
    let endDate2 = new Date(`${startYear}/${startMonth}/${startD} 23:59:59`)
    this.datePicker2 =[formatDate(new Date(startDate2), 'yyyy-MM-dd hh:mm:ss'),formatDate(new Date(endDate2), 'yyyy-MM-dd hh:mm:ss')]
    
  },
  mounted() {
    
    // if (this.$store.state.reloadState === false) {
    //   this.$store.state.reloadState = true
    //   this.$parent.reload()
    // }else{
      this.getManiceList()
      this.getParameter()
      let newMachineID = localStorage.getItem('newMachineID')
      if (newMachineID !== null) {
        this.machineID = [Number(this.$store.state.defaultFactoryId), Number(newMachineID)]
      }else{
        this.machineID = [Number(this.$store.state.defaultFactoryId), Number(this.$store.state.defaultId)]
      }
    // }
    this.$store.commit('authority' , this.$route.path)
    this.getShiftTime()
    // this.showBtn()
    // this.showBtn2()
    this.showBtnOne()
  },
  destroyed() {
    clearInterval(this.resizeTimer)
    clearInterval(this.resizeTimer2)
  },
  beforeRouteLeave (to, from, next) {
    if(to.name==='ProductionAnalysis'||to.name==='EP002'||to.name==='EP003'){
      next()
    }else{
      localStorage.removeItem('newMachineID')
      next()
    }         
  },
  methods: {
    //切换tabs
    handleClick(tab){
      if (tab.name === 'week') {
        this.$router.push({path: '/EP002', name: 'EP002'})
      }else if(tab.name === 'month'){
        this.$router.push({path: '/EP003', name: 'EP003'})
      }
    },
    // 切换设备
    getchange(value){
      this.machineID[0] = this.$store.state.defaultFactoryId
      this.machineID[1]=value
      localStorage.newMachineID =value
      this.getShiftTime()
      this.getAllDate()
    },
    // 获取查询的默认即那个时间和起始时间
    getParameter(){
      let hours = localStorage.getItem('hours')
      let Xtime = localStorage.getItem('Xtime')
      let hours2 = localStorage.getItem('hours2')
      let Xtime2 = localStorage.getItem('Xtime2')

      if (hours !== null) {
        this.selectValue1 = hours
      }
      if (Xtime !== null) {
        this.selectValue2 = Xtime
      }
      if (hours2 !== null) {
        this.chart2selectValue1 = hours2
      }
      if (Xtime2 !== null) {
        this.chart2selectValue2 = Xtime2
      }
    },
    // 获取最近2班组，三班组时间
    getShiftTime(){
      let _this = this
      function format(st){
        var time = new Date(st);
        var y = time.getFullYear();
        var m = time.getMonth()+1;
        var d = time.getDate();
        var h = time.getHours();
        var mm = time.getMinutes();
        var s = time.getSeconds();
        return y+'-'+checkTime(m)+'-'+checkTime(d)+' '+checkTime(h)+':'+checkTime(mm)+':'+checkTime(s);
      }
      function checkTime(i){
        if (i<10) {
          i="0" + i
        }
        return i
      }
      this.axios({
        method: 'get',
        url: '/url/selectLastShiftTime',
        params:{
          machineId: _this.machineID[1]
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          let twoShiftArr = [format(res.data.two.shiftStartTime), format(res.data.two.shiftEndTime)]
          let threeShiftArr = [format(res.data.three.shiftStartTime), format(res.data.three.shiftEndTime)]
          _this.twoShiftArr = twoShiftArr
          _this.threeShiftArr = threeShiftArr
        }else{
          _this.$message.error(res.data.msg);
        }
      })
    },
    // 获取车间列表
    getManiceList() {
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/selectChooseManice',
        params:{
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          if(res.data.options !==undefined && res.data.options.length > 0){
            // _this.noMachine=false
            if(localStorage.getItem('isMarketAccount') === '1') {
              _this.$store.commit('marketAccount',res.data.options)
            }
            _this.options = res.data.options
          }
          // else{
          //   _this.noMachine=true
          // }
        } else {
          _this.$message.error('Machine list loading failed')
        }
      })
    },
    handleconfirm(){
      this.fullscreenLoading = true
      this.dialogVisible = false
      localStorage.hours = this.selectValue1
      localStorage.Xtime = this.selectValue2
      localStorage.hours2 = this.chart2selectValue1
      localStorage.Xtime2 = this.chart2selectValue2
      if (this.showSelect === 'a') {
        this.getData()
      } else {
        this.getData2()
      }
    },
    handleCancle(){
      let hours = localStorage.getItem('hours')
      let Xtime = localStorage.getItem('Xtime')
      let hours2 = localStorage.getItem('hours2')
      let Xtime2 = localStorage.getItem('Xtime2')
      if(hours === null){
        this.selectValue1 = '2'
      } else {
        this.selectValue1 = hours
      }
      if(Xtime === null){
        this.selectValue2 = '2'
      } else {
        this.selectValue2 = Xtime
      }
      if(hours2 === null){
        this.chart2selectValue1 = '2'
      } else {
        this.chart2selectValue1 = hours2
      }
      if(Xtime2 === null){
        this.chart2selectValue2 = '2'
      } else {
        this.chart2selectValue2 = Xtime2
      }
      this.dialogVisible = false
    },
    // 查询按钮
    showBtn(){
      let id = this.machineID[this.machineID.length-1]
      let date= this.datePicker
      if (id === undefined) {
        this.$message.error(this.$t('Production.error1'));
      } else if(date === null){
        this.$message.error(this.$t('Production.error2'));
      } else if(id !== undefined && date !== null){
        this.fullscreenLoading = true;
        this.chart1Info.time = date
        this.chart1Info.machineId = this.machineID
        this.getData()
      }
    },
    showBtn2(){
      let id = this.machineID[this.machineID.length-1]
      let date= this.datePicker2
      if (id === undefined) {
        this.$message.error(this.$t('Production.error1'));
      } else if(date === null){
        this.$message.error(this.$t('Production.error2'));
      } else if(id !== undefined && date !== null){
        this.fullscreenLoading = true;
        this.chart2Info.time = date
        this.chart2Info.machineId = this.machineID
        this.getData2()
      }
    },
    //两个图表都刷新
    showBtnOne(){
      let id = this.machineID[this.machineID.length-1]
      let date= this.datePicker
      if (id === undefined) {
        this.$message.error(this.$t('Production.error1'));
      } else if(date === null){
        this.$message.error(this.$t('Production.error2'));
      } else if(id !== undefined && date !== null){
        this.chart1Info.time = date
        this.chart1Info.machineId = this.machineID
        this.showBtnTwo()
      }
    },
    showBtnTwo(){
      let id = this.machineID[this.machineID.length-1]
      let date= this.datePicker2
      if (id === undefined) {
        this.$message.error(this.$t('Production.error1'));
      } else if(date === null){
        this.$message.error(this.$t('Production.error2'));
      } else if(id !== undefined && date !== null){
        this.chart2Info.time = date
        this.chart2Info.machineId = this.machineID
        this.getAllDate()
      }
    },
    // 获取数据s
    getData(){
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/getProductionRecordData',
        params:{
          factoryId: _this.chart1Info.machineId[0],
          machineId: _this.chart1Info.machineId[1],
          codes: _this.radio,
          startTime: _this.chart1Info.time[0],
          endTime: _this.chart1Info.time[1],
          language: _this.$store.state.lang,
          hours: _this.selectValue1,
          Xtime: _this.selectValue2,
        }
      }).then(function(res){
        if ( res.data.success === 'true') {
          _this.noMachine=false
          if(res.data.machineInfo!=null){
            _this.dlmachineId=_this.chart1Info.machineId[1]
            _this.dltime=_this.chart1Info.time
            _this.timeArr = []
            _this.numArr = []
            _this.workTimeArr = []
            _this.pointPosition = []
            for (const item of res.data.info) {
              _this.timeArr.push(item.hours + '['+ item.shiftName +']')
              _this.numArr.push(item.num)
            }
            for (const pinitItem of res.data.scatterPointList) {
              let positipon = [pinitItem.timeStamp, pinitItem.cycleTime]
              _this.pointPosition.push(positipon)
            }
            _this.machineTitle = res.data.machineInfo.equipmentName+'('+res.data.machineInfo.nameEn+')'
            if (_this.datePicker !== null && _this.datePicker !== '') {
              _this.titleStartTime =  _this.datePicker[0]
              _this.titleEndTime =  _this.datePicker[1]
            }
            _this.fullscreenLoading = false
            _this.initDayChart()
          }
          else{
            _this.noMachine=true
            _this.fullscreenLoading=false
          }
        } else {
          if (_this.numArr.length != 0){
            _this.titleStartTime =  res.data.startTime
            _this.titleEndTime =  res.data.endTime
            _this.machineTitle = res.data.machineInfo.equipmentName+'('+res.data.machineInfo.nameEn+')'
            _this.barChart.clear()
          }
           _this.noMachine=true
          _this.fullscreenLoading = false
          // _this.$message.error(res.data.msg);
        }
      })
    },
    getData2(){
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/getProductionRecordData',
        params:{
          factoryId: _this.chart2Info.machineId[0],
          machineId: _this.chart2Info.machineId[1],
          codes: _this.radio2,
          startTime: _this.chart2Info.time[0],
          endTime: _this.chart2Info.time[1],
          language: _this.$store.state.lang,
          hours: _this.chart2selectValue1,
          Xtime: _this.chart2selectValue2
        }
      }).then(function(res){
        if ( res.data.success === 'true') {
          _this.noMachine2=false
          if(res.data.machineInfo!=null){
            _this.dlmachineId2=_this.chart2Info.machineId[1]
            _this.dltime2=_this.chart2Info.time
            _this.chart2_timeArr= []
            _this.chart2_numArr = []
            _this.chart2_workTimeArr= []
            _this.pointPosition2 = []
            for (const item2 of res.data.info) {
              _this.chart2_timeArr.push(item2.hours + '['+ item2.shiftName +']')
              _this.chart2_numArr.push(item2.num)
            }
            for (const pinitItem2 of res.data.scatterPointList) {
              let positipon = [pinitItem2.timeStamp, pinitItem2.cycleTime]
              _this.pointPosition2.push(positipon)
            }
            _this.machineTitle2 = res.data.machineInfo.equipmentName+'('+res.data.machineInfo.nameEn+')'
            if (_this.datePicker2 !== null && _this.datePicker2 !== '') {
              _this.titleStartTime2 =  _this.datePicker2[0]
              _this.titleEndTime2 =  _this.datePicker2[1]
            }
            _this.fullscreenLoading = false
            _this.initDayChart2()
          }else{
            _this.noMachine2=true
            _this.fullscreenLoading=false
          }
        } else {
           if (_this.chart2_numArr.length != 0){
            _this.titleStartTime2 =  res.data.startTime
            _this.titleEndTime2 =  res.data.endTime
            _this.machineTitle2 = res.data.machineInfo.equipmentName+'('+res.data.machineInfo.nameEn+')'
            _this.barChart2.clear()
          }
          _this.noMachine2=true
          _this.fullscreenLoading = false
          // _this.$message.error(res.data.msg);
        }
      })
    },
    //all方法调用获取图表1内容
    getDataOne(){
      let _this = this
      return this.axios({
        method: 'get',
        url: '/url/getProductionRecordData',
        params:{
          factoryId: _this.chart1Info.machineId[0],
          machineId: _this.chart1Info.machineId[1],
          codes: _this.radio,
          startTime: _this.chart1Info.time[0],
          endTime: _this.chart1Info.time[1],
          language: _this.$store.state.lang,
          hours: _this.selectValue1,
          Xtime: _this.selectValue2,
        }
      })
    },
    //all方法调用获取图表2内容
    getDataTwo(){
      let _this = this
      return this.axios({
        method: 'get',
        url: '/url/getProductionRecordData',
        params:{
          factoryId: _this.chart2Info.machineId[0],
          machineId: _this.chart2Info.machineId[1],
          codes: _this.radio2,
          startTime: _this.chart2Info.time[0],
          endTime: _this.chart2Info.time[1],
          language: _this.$store.state.lang,
          hours: _this.chart2selectValue1,
          Xtime: _this.chart2selectValue2
        }
      })
    },
    //调用两个获取图表数据方法
    getAllDate(){
      let _this = this
      this.fullscreenLoading = true
      this.axios.all([_this.getDataOne(),_this.getDataTwo()])
        .then(this.axios.spread(function(res1, res2){
            if ( res1.data.success === 'true') {
            _this.noMachine=false
            if(res1.data.machineInfo!=null){
              _this.dlmachineId=_this.chart1Info.machineId[1]
              _this.dltime=_this.chart1Info.time
              _this.timeArr = []
              _this.numArr = []
              _this.workTimeArr = []
              _this.pointPosition = []
              for (const item of res1.data.info) {
                _this.timeArr.push(item.hours + '['+ item.shiftName +']')
                _this.numArr.push(item.num)
              }
              for (const pinitItem of res1.data.scatterPointList) {
                let positipon = [pinitItem.timeStamp, pinitItem.cycleTime]
                _this.pointPosition.push(positipon)
              }
              _this.machineTitle = res1.data.machineInfo.equipmentName+'('+res1.data.machineInfo.nameEn+')'
              if (_this.datePicker !== null && _this.datePicker !== '') {
                _this.titleStartTime =  _this.datePicker[0]
                _this.titleEndTime =  _this.datePicker[1]
              }
              _this.initDayChart()
            }
            else{
              _this.noMachine=true
            }
          } else {
            if (_this.numArr.length != 0){
              _this.titleStartTime =  res1.data.startTime
              _this.titleEndTime =  res1.data.endTime
              _this.machineTitle = res1.data.machineInfo.equipmentName+'('+res1.data.machineInfo.nameEn+')'
              _this.barChart.clear()
            }
            _this.noMachine=true
          }
            if ( res2.data.success === 'true') {
              _this.noMachine2=false
              if(res2.data.machineInfo!=null){
                _this.dlmachineId2=_this.chart2Info.machineId[1]
                _this.dltime2=_this.chart2Info.time
                _this.chart2_timeArr= []
                _this.chart2_numArr = []
                _this.chart2_workTimeArr= []
                _this.pointPosition2 = []
                for (const item2 of res2.data.info) {
                  _this.chart2_timeArr.push(item2.hours + '['+ item2.shiftName +']')
                  _this.chart2_numArr.push(item2.num)
                }
                for (const pinitItem2 of res2.data.scatterPointList) {
                  let positipon = [pinitItem2.timeStamp, pinitItem2.cycleTime]
                  _this.pointPosition2.push(positipon)
                }
                _this.machineTitle2 = res2.data.machineInfo.equipmentName+'('+res2.data.machineInfo.nameEn+')'
                if (_this.datePicker2 !== null && _this.datePicker2 !== '') {
                  _this.titleStartTime2 =  _this.datePicker2[0]
                  _this.titleEndTime2 =  _this.datePicker2[1]
                }
                _this.initDayChart2()
              }else{
                _this.noMachine2=true
              }
            } else {
              if (_this.chart2_numArr.length != 0){
                _this.titleStartTime2 =  res2.data.startTime
                _this.titleEndTime2 =  res2.data.endTime
                _this.machineTitle2 = res2.data.machineInfo.equipmentName+'('+res2.data.machineInfo.nameEn+')'
                _this.barChart2.clear()
              }
              _this.noMachine2=true
          }
          _this.fullscreenLoading = false
        }))    
      },
    // 柱形图初始化
    initDayChart(){
      let _this = this
      _this.barChart = this.$echarts.init(document.getElementById('myDayChart'))
      _this.barChart.setOption({
        color: ['#3398DB'],
        tooltip : {
          trigger: 'item',
          formatter: function(params){
            let res = params.name
            function format(st){
              var time = new Date(st);
              var y = time.getFullYear();
              var m = time.getMonth()+1;
              var d = time.getDate();
              var h = time.getHours();
              var mm = time.getMinutes();
              var s = time.getSeconds();
              return y+'-'+checkTime(m)+'-'+checkTime(d)+' '+checkTime(h)+':'+checkTime(mm)+':'+checkTime(s);
            }
            function checkTime(i){
              if (i<10) {
                i="0" + i
              }
              return i
            }
            if (params.componentSubType==='bar') {
              res = res + `<br/> ${params.marker} ${params.seriesName} : ${params.data} `
            } else {
              res = `${params.marker} ${params.seriesName} : ${params.data[1]} " <br/> ${params.marker} ${_this.$t('Production.tips')} : ${format(params.data[0])}`
            }
            
            return res
          },
          axisPointer : {
            type : 'shadow'
          }
        },
        toolbox: {
          show: true,
          itemSize:30,
          feature: {
            //刷新页面后图表配置弹窗不出现，为解决此问题，将按钮挪出
            //  myTool:{
            //   show:true,
            //   title:' ',
            //     icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAMAAAB+ITwmAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3FpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpiZTdmZjI2Zi1lYjY0LTdmNGMtYjRkYy04YTc5NTJhZjUzNTIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RjhGQ0NEQUY0QkE5MTFFOTgwRkJGNUJCREY2OTM1MTIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RjhGQ0NEQUU0QkE5MTFFOTgwRkJGNUJCREY2OTM1MTIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjBmNjIyOWI0LWJkNDItZGM0YS1iNDljLTIyZTFiYTgwNzZhYSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpiZTdmZjI2Zi1lYjY0LTdmNGMtYjRkYy04YTc5NTJhZjUzNTIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6Fnr0hAAAANlBMVEX////h4eEoJibu7u5ZVVXd3d3j4+P8/PzMzMyysbH+/v52cnLz8/OPjY3q6upLSkrp6env7+9jECdJAAAAa0lEQVR42tyTyxKAIAhFMRAflen//2xa68DJFo13weoMnAUXIrIRwhgBswMhLhdgkagMgwElZgIkrNt7BGlpIQx17gOHLFlNV0Oay2H9JfTs8sGhO55w1EXb0o38/Os6qoZJLmwqoNf+FGAA8GAC4lmPVMIAAAAASUVORK5CYII=',
            //     option:{},  
            //     onclick:function() {
            //       console.log('111')
            //       _this.dialogVisible = true
            //       console.log(_this.dialogVisible)
            //       _this.showSelect = 'a'
            //     }
            // },
            saveAsImage: {
              name: 'Green Tire Count',
              title:' ',
              icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAMAAAB+ITwmAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3FpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpiZTdmZjI2Zi1lYjY0LTdmNGMtYjRkYy04YTc5NTJhZjUzNTIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RUVGMkVDN0U0QkE5MTFFOUI1QjlEN0M3MTcwRDYwRUQiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RUVGMkVDN0Q0QkE5MTFFOUI1QjlEN0M3MTcwRDYwRUQiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjBmNjIyOWI0LWJkNDItZGM0YS1iNDljLTIyZTFiYTgwNzZhYSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpiZTdmZjI2Zi1lYjY0LTdmNGMtYjRkYy04YTc5NTJhZjUzNTIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7PlZeJAAAAM1BMVEX////h4eEoJib8/Pzj4+OysbHu7u75+flLSkr+/v5+fn7d3d3MzMzq6urp6env7++VlZXRcGIdAAAAZ0lEQVR42tyTSw6AIAwFH6WtogLe/7SaGDeghY2JOutJm34egrIzYA3Q5GHgUwabxu4wHBq4byvDRETyBmWlk+W2ihzCOBuNpDLqvUhpXKxOCuORA/QM/Yuv64iaRjuwMaMd+02AAQA9ewKBbQnBzgAAAABJRU5ErkJggg=='
            },
            myTool2:{
              show: _this.$store.state.authority.PageDownload.show,
              title:' ',
                icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAYAAABJ/8wUAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo3OUE4Mzk1ODYwMTMxMUU5OTkwREUyNUEyNUFCODVGMyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo3OUE4Mzk1OTYwMTMxMUU5OTkwREUyNUEyNUFCODVGMyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjc5QTgzOTU2NjAxMzExRTk5OTBERTI1QTI1QUI4NUYzIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjc5QTgzOTU3NjAxMzExRTk5OTBERTI1QTI1QUI4NUYzIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+dmf26AAAAWpJREFUeNpivHfvHhsDA0M3EMcAsRADfcF7IF4MxKUsQKKLk5MzT1RUlIGZmZmurvj796/g69ev874DAROQHzsQjgABkJ0gu4EgFeQQoYFwBLJjQG5gYhgkgIUYRVdvPmZYvngmw+fPn/GqMzc3Z4iKiiLLIUSFCDGOAIGTJ08yLFu2jHYhAnPExIkTcarJz8+HOwYESA0ZmqQRckKGZomVVMfQNNeQ4hiaZ19YmqFKYiUGYEvIsAQ8KEJkyDmEoqjZuWMHw7bt28FsL09PBncPj6EfIkM7as6dO8ewcOFCFDFQFIEwuRUfWSFiZGTEEB8fT//alxjHUOIIinMNyDEgcOPGDYocQZWSFeQYmINo7hBeXl5wm4SUIhsG5OXkqJdGgoKCiDYQ3QMOjo7UCxFqBf+QKVnfAXtcA+YAqN3vQA5Z/ObNG4aBcMyfP38YQHYDwRxQGin79u0b46NHj2KBbMEB6oTXAgQYAEk/geeSh3YUAAAAAElFTkSuQmCC',
                option:{},
                onclick:function() {
                  let startTime = ''
                  let endTime = ''
                  if (_this.dltime !== null && _this.dltime !== '') {
                    startTime = _this.dltime[0]
                    endTime = _this.dltime[1]
                  }
                  let signTime = new Date().getTime()
                  _this.$store.commit('nowsign', signTime)
                  let urlData = '?machineId=' + _this.dlmachineId + '&codes=' + _this.radio + '&startTime=' + startTime + '&endTime=' + endTime + '&factoryId=' + _this.chart1Info.machineId[0] + '&language='+ _this.$store.state.lang+'&sign='+_this.$store.state.sign + '&auth_Code='+_this.$store.state.authCode+'&sign_time='+signTime+'&route='+_this.$store.state.newroute+'&factory_id='+_this.$store.state.factoryId
                  window.open('/url/excelExportProductionRecordData' + urlData, '_blank')
                  
                }
            }
          }
        },
        dataZoom: [{
            type: 'slider',
            xAxisIndex: [0,1],
            filterMode: 'weakFilter',
            height: 20,
            width: '90%',
            bottom: 0,
            start: 0,
            end: 100,
            handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
            handleSize: '80%',
            showDetail: false
        },{
            type: 'inside',
            id: 'insideX',
            xAxisIndex: [0,1],
            filterMode: 'weakFilter',
            start: 0,
            end: 100,
            zoomOnMouseWheel: true,
            moveOnMouseMove: true
        }],
        grid: {
          top:'11%',
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis : [
          {
            type : 'category',
            data : _this.timeArr,
            axisTick: {
                alignWithLabel: true
            },
            axisLabel: {        
              show: true,
              textStyle: {
                  fontSize:'10'
              }
            }

          },
          {
            type : 'time',
            position: 'top',
            axisTick: {
                alignWithLabel: true
            }
          }
        ],
        yAxis : [
          {
            type : 'value',
            name : _this.$t('Production.Ylabel'),
            nameGap: 35,
            interval: 10,
            position: 'left'
          },
          {
            type : 'value',
            name : _this.$t('Production.Ylabel2'),
            nameGap: 35,
            position: 'right'
          }
        ],
        series : [
          {
            name: _this.$t('Production.placehoderLabel'),
            type:'bar',
            animation: false,
            label: {
                normal: {
                    show: true,
                    position: 'insideTop',
                    color: '#000'
                }
            },
            data: _this.numArr
          },
          {
            name:_this.$t('Production.Ylabel2'),
            type:'scatter',
            animation: false,
            xAxisIndex:1,
            yAxisIndex: 1,
            symbolSize: 8,
            itemStyle: {
              color:'red'
            },
            data: _this.pointPosition
          }
        ]
      })
      this.resizeTimer = setInterval(function(){
        _this.barChart.resize()
      },1000)
    },
    initDayChart2(){
      let _this = this
      _this.barChart2 = this.$echarts.init(document.getElementById('myDayChart2'))
      _this.barChart2.setOption({
        color: ['#3398DB'],
        tooltip : {
          trigger: 'item',
          formatter: function(params){
            let res = params.name
            function format(st){
              var time = new Date(st);
              var y = time.getFullYear();
              var m = time.getMonth()+1;
              var d = time.getDate();
              var h = time.getHours();
              var mm = time.getMinutes();
              var s = time.getSeconds();
              return y+'-'+checkTime(m)+'-'+checkTime(d)+' '+checkTime(h)+':'+checkTime(mm)+':'+checkTime(s);
            }
            function checkTime(i){
              if (i<10) {
                i="0" + i
              }
              return i
            }
            if (params.componentSubType==='bar') {
              res = res + `<br/> ${params.marker} ${params.seriesName} : ${params.data} `
            } else {
              res = `${params.marker} ${params.seriesName} : ${params.data[1]} " <br/> ${params.marker} ${_this.$t('Production.tips')} : ${format(params.data[0])}`
            }
            
            return res
          },
          axisPointer : {
            type : 'shadow'
          }
        },
        toolbox: {
          show: true,
          itemSize:30,
          feature: {
            //刷新页面后图表配置弹窗不出现，为解决此问题，将按钮挪出
            //  myTool:{
            //   show:true,
            //   title:' ',
            //     icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAMAAAB+ITwmAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3FpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpiZTdmZjI2Zi1lYjY0LTdmNGMtYjRkYy04YTc5NTJhZjUzNTIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RjhGQ0NEQUY0QkE5MTFFOTgwRkJGNUJCREY2OTM1MTIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RjhGQ0NEQUU0QkE5MTFFOTgwRkJGNUJCREY2OTM1MTIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjBmNjIyOWI0LWJkNDItZGM0YS1iNDljLTIyZTFiYTgwNzZhYSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpiZTdmZjI2Zi1lYjY0LTdmNGMtYjRkYy04YTc5NTJhZjUzNTIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6Fnr0hAAAANlBMVEX////h4eEoJibu7u5ZVVXd3d3j4+P8/PzMzMyysbH+/v52cnLz8/OPjY3q6upLSkrp6env7+9jECdJAAAAa0lEQVR42tyTyxKAIAhFMRAflen//2xa68DJFo13weoMnAUXIrIRwhgBswMhLhdgkagMgwElZgIkrNt7BGlpIQx17gOHLFlNV0Oay2H9JfTs8sGhO55w1EXb0o38/Os6qoZJLmwqoNf+FGAA8GAC4lmPVMIAAAAASUVORK5CYII=',
            //     option:{},  
            //     onclick:function() {
            //       _this.dialogVisible = true
            //       _this.showSelect = 'b'
            //     }
            // },
            saveAsImage: {
              name: 'Green Tire Count',
              title:' ',
              icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAMAAAB+ITwmAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3FpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpiZTdmZjI2Zi1lYjY0LTdmNGMtYjRkYy04YTc5NTJhZjUzNTIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RUVGMkVDN0U0QkE5MTFFOUI1QjlEN0M3MTcwRDYwRUQiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RUVGMkVDN0Q0QkE5MTFFOUI1QjlEN0M3MTcwRDYwRUQiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjBmNjIyOWI0LWJkNDItZGM0YS1iNDljLTIyZTFiYTgwNzZhYSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpiZTdmZjI2Zi1lYjY0LTdmNGMtYjRkYy04YTc5NTJhZjUzNTIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7PlZeJAAAAM1BMVEX////h4eEoJib8/Pzj4+OysbHu7u75+flLSkr+/v5+fn7d3d3MzMzq6urp6env7++VlZXRcGIdAAAAZ0lEQVR42tyTSw6AIAwFH6WtogLe/7SaGDeghY2JOutJm34egrIzYA3Q5GHgUwabxu4wHBq4byvDRETyBmWlk+W2ihzCOBuNpDLqvUhpXKxOCuORA/QM/Yuv64iaRjuwMaMd+02AAQA9ewKBbQnBzgAAAABJRU5ErkJggg=='
            },
            myTool2:{
              show: _this.$store.state.authority.PageDownload.show,
              title:' ',
                icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAYAAABJ/8wUAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo3OUE4Mzk1ODYwMTMxMUU5OTkwREUyNUEyNUFCODVGMyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo3OUE4Mzk1OTYwMTMxMUU5OTkwREUyNUEyNUFCODVGMyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjc5QTgzOTU2NjAxMzExRTk5OTBERTI1QTI1QUI4NUYzIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjc5QTgzOTU3NjAxMzExRTk5OTBERTI1QTI1QUI4NUYzIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+dmf26AAAAWpJREFUeNpivHfvHhsDA0M3EMcAsRADfcF7IF4MxKUsQKKLk5MzT1RUlIGZmZmurvj796/g69ev874DAROQHzsQjgABkJ0gu4EgFeQQoYFwBLJjQG5gYhgkgIUYRVdvPmZYvngmw+fPn/GqMzc3Z4iKiiLLIUSFCDGOAIGTJ08yLFu2jHYhAnPExIkTcarJz8+HOwYESA0ZmqQRckKGZomVVMfQNNeQ4hiaZ19YmqFKYiUGYEvIsAQ8KEJkyDmEoqjZuWMHw7bt28FsL09PBncPj6EfIkM7as6dO8ewcOFCFDFQFIEwuRUfWSFiZGTEEB8fT//alxjHUOIIinMNyDEgcOPGDYocQZWSFeQYmINo7hBeXl5wm4SUIhsG5OXkqJdGgoKCiDYQ3QMOjo7UCxFqBf+QKVnfAXtcA+YAqN3vQA5Z/ObNG4aBcMyfP38YQHYDwRxQGin79u0b46NHj2KBbMEB6oTXAgQYAEk/geeSh3YUAAAAAElFTkSuQmCC',
                option:{},
                onclick:function() {
                  let startTime = ''
                  let endTime = ''
                  if (_this.dltime2 !== null && _this.dltime2 !== '') {
                    startTime = _this.dltime2[0]
                    endTime = _this.dltime2[1]
                  }
                  let signTime = new Date().getTime()
                  _this.$store.commit('nowsign', signTime)
                  let urlData = '?machineId=' + _this.dlmachineId2 + '&codes2=' + _this.radio2 + '&startTime2=' + startTime + '&endTime2=' + endTime + '&factoryId=' + _this.chart2Info.machineId[0] + '&language='+ _this.$store.state.lang+'&sign='+_this.$store.state.sign + '&auth_Code='+_this.$store.state.authCode+'&sign_time='+signTime+'&route='+_this.$store.state.newroute+'&factory_id='+_this.$store.state.factoryId
                  window.open('/url/excelExportProductionRecordData2' + urlData, '_blank')
                  
                }
            }
          }
        },
        dataZoom: [{
            type: 'slider',
            xAxisIndex: [0],
            filterMode: 'weakFilter',
            height: 20,
            width: '90%',
            bottom: 0,
            start: 0,
            end: 100,
            handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
            handleSize: '80%',
            showDetail: false
        },{
            type: 'inside',
            id: 'insideX',
            xAxisIndex: [0],
            filterMode: 'weakFilter',
            start: 0,
            end: 100,
            zoomOnMouseWheel: true,
            moveOnMouseMove: true
        }],
        grid: {
          left: '3%',
          right: '7.5%',
          bottom: '3%',
          containLabel: true
        },
        xAxis : [
          {
            type : 'category',
            data : _this.chart2_timeArr,
            axisTick: {
                alignWithLabel: true
            },
            axisLabel: {        
              show: true,
              textStyle: {
                  fontSize:'10'
              }
            }

          }
        ],
        yAxis : [
          {
            type : 'value',
            name : _this.$t('Production.Ylabel'),
            nameGap: 10,
            interval: 10,
            position: 'left',
          }
        ],
        series : [
          {
            name: _this.$t('Production.placehoderLabel'),
            type:'bar',
            animation: false,
            label: {
                normal: {
                    show: true,
                    position: 'insideTop',
                    color: '#000'
                }
            },
            data: _this.chart2_numArr
          },
        ]
      })
      this.resizeTimer2 = setInterval(function(){
        _this.barChart2.resize()
      },1000)
    },
    //测试
    saveLeft(){
      this.dialogVisible = true
      this.showSelect = 'a'
    },
    saveRight(){
      this.dialogVisible = true
      this.showSelect = 'b'
    },
    // 清除禁用
    clearDis(){
      if (this.datePicker === null) {
        this.pickerMinDate = ''
      }
      this.showBtn()
    },
    clearDis2(){
      if (this.datePicker2 === null) {
        this.pickerMinDate2 = ''
      }
      this.showBtn2()
    }
  }
}
</script>
<style scoped>
.ProductionRecord{
  min-width: 1365px!important;
}
.mainWrao{
  height: 100%;
  width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}
.seach{
  padding: 15px 10px;
  
}
.seach button{
  float: right;
}

#chartWrap .chartTitle{
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.dialog-title{
  font-size: 20px;
}
.axis{
  font-weight: bold;
  position: relative;
}
.axis:after{
  content: '';
  position: absolute;
  background:  rgba(229, 229, 229);
  height: 1px;
  width: 435px;
  top: 10px;
  left: 55px;
}
.dialogSelect{
  width: 390px;
  margin: 10px auto 0;
}
.dialogSelect label{
  display: inline-block;
  width: 160px;
}
.dialog-footer button{
  width: 90px;
}
.radioWrap{
  margin-right: 80px;
}
.recordTitle .machineSeach{
  float: right;
  display:flex;
  align-items:center;
}
.barWrap{
  display: flex;
  min-height: 835px;
}
.barTabs{
  width: 100%;
}
.barTabsDay{
  display: flex;
}
.barWrap .barChart{
  width: 50%;
  margin: 5px 5px 30px;
  border-radius: 2px;
  background-color: #fff;
  box-shadow: 0 2px 2px 0 rgba(0,0,0,0.5);
}
#chartWrap p{
  text-align: center;
  color: rgba(166, 166, 166, 1);
  font-size: 16px;
  margin: 5px 0;
}
.interval{
  margin: 0 10px;
  font-size: 14px;
}
.el-date-editor--datetimerange.el-input, .el-date-editor--datetimerange.el-input__inner{
  width: 380px;
}
.noMachineTitle{
  color:#909399;
  line-height: 100px;
  text-align: center;
  /* font-size: 20px; */
}
.chartLine{
  display: flex;
  position: relative;
}
.chartTopTitle{
  flex:1
}
.chartConfiguration{
  /* margin-right:5px;
  margin-top:24px; */
  position:absolute;
  top:61.5px;
  right:81px;
  z-index: 10;
}
.chartConfiguration .el-button--mini, .el-button--mini.is-round {
  padding: 6.9px 6.8px;
  box-shadow: 0.5px 0.5px 0.5px 0px rgb(207 203 203 / 30%);
}
.chartConfiguration .el-button--mini, .el-button--small {
  font-size: 14px;
}
.chartConfiguration .el-button:active {
  color:#606266;
  border-color: #DCDFE6;
  outline: 0;
}
.chartConfiguration .el-button:hover {
  color: #606266;
  border-color: #DCDFE6;
  background-color: #fff;
}
</style>

